import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useToastifyStore } from "../../stores/toastifyStore";


export default function ToastifyContainer() {
  const Toast = useToastifyStore(t => t.toast);
  const deleteToast = useToastifyStore(t => t.deleteToast);

  useEffect(() => {
    if (Toast.content === "") {
      return
    }
    toast(Toast.content, { theme: "dark", type: Toast.type })
    deleteToast();
  }, [Toast, deleteToast])

  return (
    <ToastContainer rtl={true}  />
  )
}